import { Component, OnInit } from '@angular/core';
import { UserMgmtService } from '../user.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {
  isLoading;
  stateList;
  mobilePattern = /^[0][1-9][0-9]*$/;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  addUserForm: FormGroup;
  roles = [];

  constructor(
    private userservice: UserMgmtService,
    private formBuilder: FormBuilder,
    private router: Router,
  
    private _snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.initializeForm();
    this.getstateList();

  }

  initializeForm() {
    this.addUserForm = this.formBuilder.group({
      fullName: ["", [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      mobile: ["", [Validators.minLength(10)]],
      address: ["", [Validators.required]],
      password: ["", [Validators.required]],
      stateId: ["", [Validators.required]],
      role: ["", [Validators.required]]
    });
  }

  onlyAlphabets(e) {
    return (e.charCode > 64 && e.charCode < 91) || (e.charCode > 96 && e.charCode < 123) || e.charCode == 32 || e.charCode == 45;
  }

  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  inputNumber(event) {
    let mobile = this.addUserForm.value.mobile;
    let first = mobile.charAt(0)
    if (first == "0") {
      this.addUserForm.controls['mobile'].setValidators([Validators.minLength(11)]);
      this.addUserForm.controls['mobile'].updateValueAndValidity();
    }
    else {
      this.addUserForm.controls['mobile'].setValidators([Validators.minLength(10)]);
      this.addUserForm.controls['mobile'].updateValueAndValidity();
    }
  }

  getstateList() {
    this.isLoading = true;
    this.userservice.getStateIdList().subscribe(
      res => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.stateList = res["data"]["stateList"];
        } else {
          this.stateList = [];
        }
        this.isLoading = false;
      },
      err => {
        this.isLoading = false;
      }
    );
  }

 

  submitUser() {
    if (this.addUserForm.valid) {
      this.verifyUser();
    }
  }

  verifyUser() {
    this.isLoading = true;
    let request = {
      "mobile": this.addUserForm.value.mobile,
      "email": this.addUserForm.value.email
    }
    this.userservice.verifyUser(request).subscribe(
      res => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.saveUser();
        } else {
        }
        this.isLoading = false;
      },
      err => {
        this.isLoading = false;
      }
    );
  }

  saveUser() {
    this.isLoading = true;
    // let request = this.addUserForm.value;
    let request = {
      ...this.addUserForm.value
    };
    request['mobile'] = this.addUserForm.value.mobile;

    // console.log(request);
    this.userservice.saveUser(request).subscribe(
      res => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this._snackBar.open("User created successfully!","",{
            duration: 5000,
            horizontalPosition:'right',
            verticalPosition:'top',
            panelClass: ['success']
          });
          // Swal.fire("Success", "User created successfully!", "success");
          this.router.navigate(["/main/user-management/view-user"]);
          this.addUserForm.reset();
        } else {
        }
        this.isLoading = false;
      },
      err => {
        this.isLoading = false;
      }
    );
  }
}
